module.exports = __webpack_public_path__ + "media/images/admin/icons/arrow-up-70d8ca827d1640720ed80c86fd48dcfa.svg";